import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import { Table } from 'antd';
import useQueryParam from 'hooks/useQueryPrams';
import React from 'react';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import formatCurrencyVND from 'utils/formatCurrencyVND';

type FixedType = 'left' | 'right' | boolean;

interface IProps {
  detailCapitalShop: any;
}

export default function PlantAllocateTab1(props: IProps) {
  const { detailCapitalShop } = props;
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const capital_ratio = detailCapitalShop.capital_ratio;
  const capital_ratio_pof = detailCapitalShop.capital_ratio_pof;
  const data = [
    {
      type: 'Vốn hàng hóa',
      per_min: capital_ratio?.per_cap_order_min || 0,
      per_max: capital_ratio?.per_cap_order_max || 0,
      min: capital_ratio?.cap_order_min || 0,
      max: capital_ratio?.cap_order_max || 0,
    },
    {
      type: 'Vốn mua lại',
      per_min: capital_ratio?.per_cap_reorder_min || 0,
      per_max: capital_ratio?.per_cap_reorder_max || 0,
      min: capital_ratio?.cap_reorder_min || 0,
      max: capital_ratio?.cap_reorder_max || 0,
    },
    {
      type: 'Vốn khác',
      per_min: capital_ratio?.per_cap_other_min || 0,
      per_max: capital_ratio?.per_cap_other_max || 0,
      min: capital_ratio?.cap_other_min || 0,
      max: capital_ratio?.cap_other_max || 0,
    },
  ];

  const perCapitalColumn: ColumnsType<any> = [
    {
      title: 'Loại vốn',
      dataIndex: 'type',
      width: 150,
    },
    {
      title: 'Tỉ lệ min',
      dataIndex: 'per_min',
      width: 150,
      render: (value) => {
        return `${value}%`;
      },
    },
    {
      title: 'Tỉ lệ max',
      dataIndex: 'per_max',
      width: 150,
      render: (value) => {
        return `${value}%`;
      },
    },
    {
      title: 'Vốn tồn min',
      dataIndex: 'min',
      width: 200,
      align: 'right',
      render: (value) => {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Vốn tồn max',
      dataIndex: 'max',
      width: 200,
      align: 'right',
      render: (value) => {
        return formatCurrencyVND(value);
      },
    },
    {
      fixed: 'right',
      width: 1,
    },
  ];

  const perCapitalCategoryColumn: ColumnsType<any> = [
    {
      title: 'Danh mục',
      dataIndex: 'pof_type_name',
      width: 250,
    },
    {
      title: 'Tỉ lệ min',
      dataIndex: 'ratio_min',
      width: 150,
      render: (value) => {
        return `${value}%`;
      },
    },
    {
      title: 'Tỉ lệ max',
      dataIndex: 'ratio_max',
      width: 150,
      render: (value) => {
        return `${value}%`;
      },
    },
    {
      title: 'Vốn tồn min',
      dataIndex: 'amount_min',
      align: 'right',
      width: 200,
      render: (value) => {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Vốn tồn max',
      dataIndex: 'amount_max',
      align: 'right',
      width: 200,
      render: (value) => {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Lý do',
      dataIndex: 'description',
      width: 100,
    },
    {
      fixed: 'right',
      width: 1,
    },
  ];

  return (
    <Content className="main-content">
      <Table
        title={() => 'Tỷ trọng vốn tồn'}
        rowKey={(record) => record.id}
        columns={perCapitalColumn}
        className="customTable"
        dataSource={data}
        scroll={{ x: 958 }}
        pagination={false}
        // loading={getCartsLoading}
      />
      <Table
        title={() => 'Tỷ trọng phân bổ vốn danh mục'}
        rowKey={(record) => record.id}
        columns={perCapitalCategoryColumn}
        className="customTable mt-12"
        dataSource={capital_ratio_pof}
        scroll={{ x: 958 }}
        pagination={false}
        // loading={getCartsLoading}
      />
    </Content>
  );
}
